import styled, { css } from 'styled-components';


export const MenuFooterInnerContainer = styled.div`
  border-top: 2px solid ${(props) => props.theme.colors.lightGray};
  box-sizing: border-box;
  height: 270px;
  margin-left: 3px;
  margin-right: 3px;
`;

export const PriceContainer = styled.div`
  margin-top: 35px;
  font-size: 25px;
`;

export const EzypayTextContainer = styled.div`
`;

export const ShippingTextContainer = styled.div`
  margin-top: 15px;
  text-transform: uppercase;
  text-align: center;
  font-size: 12px;
`;

export const FooterButtonContainer = styled.div`
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`;

export const FooterButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-basis: 100%;
  height: 75px;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 20px;

  border: 1px solid ${(props) => props.theme.colors.backgroundBlack};

  &:first-child {
    margin-right: 3px;
  }

  &:last-child {
    margin-left: 3px;
  }
`;

export const FooterButtonWhite = styled(FooterButton)<{inactive?:boolean}>`
  color: ${(props) => props.theme.colors.backgroundBlack};
  background-color: white;

  ${(props) => props.inactive && css`
    color: ${(props) => props.theme.colors.lightGray};
    border-color: ${(props) => props.theme.colors.darkGray};
    cursor: unset;
  `}
`;

export const FooterButtonBlack = styled(FooterButton)`
  color: white;
  background-color: ${(props) => props.theme.colors.backgroundBlack};
`;

export const MenuFooterContainer = styled.div<{mobile:boolean, menuHeight:number, menuScaleFactor:number}>`
  box-sizing: border-box;
  margin-top: auto;
  width: 100%;

  ${(props) => props.mobile && css`
    & ${MenuFooterInnerContainer} {
      height: unset;
      border-top: none;
    };
    
    & ${PriceContainer} {
      margin-top: 5px;
    };

    & ${FooterButtonContainer} {
      margin-top: 10px;
      margin-bottom: 10px;
    };

    & ${FooterButton} {
      height: 60px;
    };

    & ${ShippingTextContainer} {
      display: none;
    };
  `};

  ${(props) => props.menuHeight < 460 && css`
    & ${FooterButton} {
      height: 50px;
      font-size: ${14 * props.menuScaleFactor}px;
    };
  `};

  ${(props) => props.menuHeight < 425 && css`
    & ${FooterButtonContainer} {
      margin-top: ${10 * props.menuScaleFactor}px;
      margin-bottom: ${10 * props.menuScaleFactor}px;
    };

    & ${FooterButton} {
      height: ${40 * props.menuScaleFactor}px;
    };
  `};
`;